import { render, staticRenderFns } from "./PriceUpForm.vue?vue&type=template&id=54b64882&scoped=true&"
import script from "./PriceUpForm.vue?vue&type=script&lang=js&"
export * from "./PriceUpForm.vue?vue&type=script&lang=js&"
import style0 from "./PriceUpForm.vue?vue&type=style&index=0&id=54b64882&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b64882",
  null
  
)

export default component.exports